import { TActions } from '../../types/actions';
import {
  UPDATE_DEPOSIT_ACCOUNT_PAYMENT_TOKEN,
  UPDATE_DEPOSIT_ACCOUNT_PAYMENT_STATUS,
  UPDATE_DEPOSIT_ACCOUNT_RECOMMENDED_PACKAGE_PAYMENT_STATUS,
} from '../../actions/depositAccount';
import { IDepositAccountState } from '../../types/reducers/depositAccount';

const DEFAULT_STATE: IDepositAccountState = {
  recommendedPackagePaymentStatus: null,
  paymentStatus: null,
  paymentToken: null,
};

export function depositAccountReducer(state: IDepositAccountState, action: TActions) {
  switch (action.type) {
    case UPDATE_DEPOSIT_ACCOUNT_PAYMENT_TOKEN:
      return {
        ...state,
        paymentToken: action.payload,
      };

    case UPDATE_DEPOSIT_ACCOUNT_RECOMMENDED_PACKAGE_PAYMENT_STATUS:
      return {
        ...state,
        recommendedPackagePaymentStatus: action.payload,
      };

    case UPDATE_DEPOSIT_ACCOUNT_PAYMENT_STATUS:
      return {
        ...state,
        paymentStatus: action.payload,
      };

    default:
      return state || DEFAULT_STATE;
  }
}
